export default "__VITE_ASSET__XuZgfi9D__"